import { ReactNode } from 'react';

import {
    Box,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TrilogyColor,
    TypographyBold,
    TypographyColor,
} from '@bytel/trilogy-react';

import { UserType } from '@app-types/user';

import { BigIcon, BigIconVariant } from '@components/big';

import { formatPrice } from '@helpers/wording';

interface ContainerProps {
    user?: UserType;
    totalDiscountAmount?: number;
    hideTitle?: boolean;
    children?: ReactNode;
}

export function Container({ user, totalDiscountAmount = 0, hideTitle = false, children }: Readonly<ContainerProps>) {
    return (
        <Box
            data-cy='incentive-block'
            backgroundColor={TrilogyColor.INFO}
            shadowless
            className='is-aligned-center is-radiusless-mobile remove-section-padding'
        >
            {user && hideTitle === false && (
                <>
                    <Title inverted level={TitleLevels.FOUR} marginless>
                        Bonjour <span className='is-capitalized'>{user.given_name.toLowerCase()}</span>
                    </Title>
                    {totalDiscountAmount < 0 ? (
                        <>
                            <Spacer size={SpacerSize.ONE} />
                            <Text
                                data-cy='incentive-block-text'
                                level={TextLevels.ONE}
                                typo={[TypographyColor.TEXT_WHITE, TypographyBold.TEXT_WEIGHT_SEMIBOLD]}
                            >
                                faites {formatPrice(totalDiscountAmount)}/mois de{' '}
                                <BigIcon variant={BigIconVariant.WHITE} /> économies&nbsp;!
                            </Text>
                            <Spacer size={SpacerSize.ONE} />
                        </>
                    ) : (
                        <Spacer size={SpacerSize.FOUR} />
                    )}
                </>
            )}
            {children}
        </Box>
    );
}
